// extracted by mini-css-extract-plugin
module.exports = {"colorPopup":"#363738","colorBackground05":"rgba(42,45,44,0.5)","list":"FooterSocials_list__s4c9b","item":"FooterSocials_item__VAxHZ","img":"FooterSocials_img__L-2rT"};